import { Box, Dropdown, MenuButton } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { usePermissions } from '~/entities/common/viewer'
import { Car, userOptionsStore } from '~/shared/api'
import { TaxiparkCountryEnum } from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'
import { Button, IconButton } from '~/shared/ui/Buttons'
import { FileExportLink } from '~/shared/ui/FileExport/FileExportLink'
import {
  DotsVerticalIcon,
  DownloadIcon,
  FileIcon,
  PlusIcon,
  UploadIcon,
} from '~/shared/ui/Icons'
import { useModal } from '~/shared/ui/Modal'
import { ImportCarTemplate } from '../ImportCarTemplate'
import { ImportOsagoImageTemplate } from '../ImportOsagoImageTemplate'
import { ImportOsagoTemplate } from '../ImportOsagoTemplate'
import { ImportOsgopImageTemplate } from '../ImportOsgopImageTemplate'
import { ImportOsgopTemplate } from '../ImportOsgopTemplate'
import { ImportSubrentPaymentTemplate } from '../ImportSubrentPaymentTemplate'
import { Menu, MenuItem } from './styled'

export function HeadingExtra() {
  const { t } = useTranslation()
  const {
    canCarsUpdate,
    canExportCarDocumentsStatusReport,
    canUploadSubrentCarPayments,
  } = usePermissions()
  const { openModal, closeModal, isModalShow } = useModal()
  const {
    openModal: openOsagoModal,
    closeModal: closeOsagoModal,
    isModalShow: isOsagoModalShow,
  } = useModal()
  const {
    openModal: openOsagoImageModal,
    closeModal: closeOsagoImageModal,
    isModalShow: isOsagoImageModalShow,
  } = useModal()
  const {
    openModal: openOsgopImageModal,
    closeModal: closeOsgopImageModal,
    isModalShow: isOsgopImageModalShow,
  } = useModal()
  const {
    openModal: openOsgopModal,
    closeModal: closeOsgopModal,
    isModalShow: isOsgopModalShow,
  } = useModal()
  const {
    openModal: openSubrentPaymentModal,
    closeModal: closeSubrentPaymentModal,
    isModalShow: isSubrentPaymentModalShow,
  } = useModal()

  const isButtonActionsShow = canCarsUpdate || canExportCarDocumentsStatusReport
  const isUploadDropdownShow = canCarsUpdate || canUploadSubrentCarPayments
  const isOsgopUploadShow =
    canCarsUpdate && userOptionsStore.country === TaxiparkCountryEnum.RU

  return (
    <>
      {isUploadDropdownShow && (
        <Dropdown>
          <Button
            variant='brand'
            startDecorator={<UploadIcon />}
            component={MenuButton}
          >
            {t('button.upload')}
          </Button>
          <Menu keepMounted={true}>
            {canCarsUpdate && (
              <MenuItem onClick={openOsagoImageModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload osago images')}
              </MenuItem>
            )}
            {isOsgopUploadShow && (
              <MenuItem onClick={openOsgopImageModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload osgop images')}
              </MenuItem>
            )}
            {canCarsUpdate && (
              <MenuItem onClick={openOsagoModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload osago')}
              </MenuItem>
            )}
            {isOsgopUploadShow && (
              <MenuItem onClick={openOsgopModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload osgop')}
              </MenuItem>
            )}
            {canUploadSubrentCarPayments && (
              <MenuItem onClick={openSubrentPaymentModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload subrent payments')}
              </MenuItem>
            )}
            {canCarsUpdate && (
              <MenuItem onClick={openModal}>
                <Box sx={{ width: '20px' }}>
                  <UploadIcon />
                </Box>
                {t('button.upload list')}
              </MenuItem>
            )}
          </Menu>
        </Dropdown>
      )}

      {isButtonActionsShow && (
        <Dropdown>
          <IconButton
            data-testid='button-menu-car'
            variant='gray'
            component={MenuButton}
          >
            <DotsVerticalIcon />
          </IconButton>
          <Menu keepMounted={true}>
            <FileExportLink
              title={t('button.export documents report')}
              fnGetLink={Car.getExportCarDocumentsStatusReportLink}
              show={canExportCarDocumentsStatusReport}
              variant='menuItem'
              startDecorator={<FileIcon color={myPalette.gray['700']} />}
            />
            {canCarsUpdate && (
              <>
                <MenuItem component={Link} to='/cars/new'>
                  <Box sx={{ width: '20px' }}>
                    <PlusIcon color={myPalette.gray['700']} />
                  </Box>
                  {t('button.add a car')}
                </MenuItem>

                <FileExportLink
                  title={t('button.download car template')}
                  fnGetLink={Car.getMassImportTemplate}
                  variant='menuItem'
                  startDecorator={
                    <DownloadIcon color={myPalette.gray['700']} />
                  }
                />
              </>
            )}
          </Menu>
        </Dropdown>
      )}

      <ImportCarTemplate isShow={isModalShow} onCancel={closeModal} />
      <ImportOsagoTemplate
        isShow={isOsagoModalShow}
        onCancel={closeOsagoModal}
      />
      <ImportOsagoImageTemplate
        isShow={isOsagoImageModalShow}
        onCancel={closeOsagoImageModal}
      />
      {isOsgopUploadShow && (
        <ImportOsgopImageTemplate
          isShow={isOsgopImageModalShow}
          onCancel={closeOsgopImageModal}
        />
      )}
      {isOsgopUploadShow && (
        <ImportOsgopTemplate
          isShow={isOsgopModalShow}
          onCancel={closeOsgopModal}
        />
      )}
      <ImportSubrentPaymentTemplate
        isShow={isSubrentPaymentModalShow}
        onCancel={closeSubrentPaymentModal}
      />
    </>
  )
}
